module.exports = __webpack_public_path__ + "img/dq.f84db16d.png";